import axios from "axios";
import cookieUtils from "../../util/cookieUtils";

export default {
    state: () => ({
    }),
    mutations: {
        // setUser(state, user){
        //     state.user = user;
        // },
    },
    getters: {
        // getUser: state => {
        //     return state.user;
        // },
    },
    actions: {
        loadMetabaseDashboardUrl: (context, dashboardId) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/report/dashboard/"+dashboardId,{headers})
                .then((response) => {
                    return response.data;
                })
        }
    }
}

